module.exports = __webpack_public_path__ + "img/four-container-bg.0ba82896.png";